module.exports = __webpack_public_path__ + "media/categories/89-beebc351.png";